/**
 * 国家 ISO 代码到大洲的映射
 * 如果找不到国家代码，返回 'multi-region' (多区域)
 */

// 大洲映射：ISO 3166-1 alpha-2 国家代码 -> 大洲名称
const countryToContinentMap = {
  // 亚洲 (Asia)
  'AF': 'asia', 'AM': 'asia', 'AZ': 'asia', 'BH': 'asia', 'BD': 'asia',
  'BT': 'asia', 'BN': 'asia', 'KH': 'asia', 'CN': 'asia', 'GE': 'asia',
  'HK': 'asia', 'IN': 'asia', 'ID': 'asia', 'IR': 'asia', 'IQ': 'asia', 'IL': 'asia',
  'JP': 'asia', 'JO': 'asia', 'KZ': 'asia', 'KW': 'asia', 'KG': 'asia',
  'LA': 'asia', 'LB': 'asia', 'MO': 'asia', 'MY': 'asia', 'MV': 'asia', 'MN': 'asia',
  'MM': 'asia', 'NP': 'asia', 'KP': 'asia', 'OM': 'asia', 'PK': 'asia',
  'PS': 'asia', 'PH': 'asia', 'QA': 'asia', 'SA': 'asia', 'SG': 'asia',
  'KR': 'asia', 'LK': 'asia', 'SY': 'asia', 'TW': 'asia', 'TJ': 'asia',
  'TH': 'asia', 'TL': 'asia', 'TR': 'asia', 'TM': 'asia', 'AE': 'asia',
  'UZ': 'asia', 'VN': 'asia', 'YE': 'asia',

  // 欧洲 (Europe)
  'AX': 'europe', 'AL': 'europe', 'AD': 'europe', 'AT': 'europe', 'BY': 'europe', 'BE': 'europe',
  'BA': 'europe', 'BG': 'europe', 'HR': 'europe', 'CY': 'europe', 'CZ': 'europe',
  'DK': 'europe', 'EE': 'europe', 'FI': 'europe', 'FR': 'europe', 'DE': 'europe',
  'GI': 'europe', 'GG': 'europe', 'GR': 'europe', 'HU': 'europe', 'IS': 'europe', 'IE': 'europe', 'IM': 'europe', 'IT': 'europe',
  'JE': 'europe', 'LV': 'europe', 'LI': 'europe', 'LT': 'europe', 'LU': 'europe', 'MT': 'europe',
  'MD': 'europe', 'MC': 'europe', 'ME': 'europe', 'NL': 'europe', 'MK': 'europe',
  'NO': 'europe', 'PL': 'europe', 'PT': 'europe', 'RO': 'europe', 'RU': 'europe',
  'SM': 'europe', 'RS': 'europe', 'SK': 'europe', 'SI': 'europe', 'ES': 'europe',
  'SE': 'europe', 'CH': 'europe', 'UA': 'europe', 'GB': 'europe', 'VA': 'europe',
  'XK': 'europe', // Kosovo (非官方代码)

  // 北美洲 (US / Canada / Mexico)
  'CA': 'north-america', 'MX': 'north-america', 'US': 'north-america',

  // 中美洲 (Central America)
  'BZ': 'central-america', 'CR': 'central-america', 'SV': 'central-america', 'GT': 'central-america',
  'HN': 'central-america', 'NI': 'central-america', 'PA': 'central-america',

  // 加勒比 (Caribbean)
  'AG': 'caribbean', 'BS': 'caribbean', 'BB': 'caribbean', 'CU': 'caribbean', 'DM': 'caribbean',
  'DO': 'caribbean', 'GD': 'caribbean', 'GP': 'caribbean', 'HT': 'caribbean', 'JM': 'caribbean',
  'PR': 'caribbean', 'KN': 'caribbean', 'LC': 'caribbean', 'VC': 'caribbean', 'TT': 'caribbean',

  // 南美洲 (South America)
  'AR': 'south-america', 'BO': 'south-america', 'BR': 'south-america', 'CL': 'south-america',
  'CO': 'south-america', 'EC': 'south-america', 'FK': 'south-america', 'GF': 'south-america',
  'GY': 'south-america', 'PY': 'south-america', 'PE': 'south-america', 'SR': 'south-america',
  'UY': 'south-america', 'VE': 'south-america',

  // 非洲 (Africa)
  'DZ': 'africa', 'AO': 'africa', 'BJ': 'africa', 'BW': 'africa', 'BF': 'africa',
  'BI': 'africa', 'CV': 'africa', 'CM': 'africa', 'CF': 'africa', 'TD': 'africa',
  'KM': 'africa', 'CG': 'africa', 'CD': 'africa', 'CI': 'africa', 'DJ': 'africa',
  'EG': 'africa', 'GQ': 'africa', 'ER': 'africa', 'SZ': 'africa', 'ET': 'africa',
  'GA': 'africa', 'GM': 'africa', 'GH': 'africa', 'GN': 'africa', 'GW': 'africa',
  'KE': 'africa', 'LS': 'africa', 'LR': 'africa', 'LY': 'africa', 'MG': 'africa',
  'MW': 'africa', 'ML': 'africa', 'MR': 'africa', 'MU': 'africa', 'MA': 'africa',
  'MZ': 'africa', 'NA': 'africa', 'NE': 'africa', 'NG': 'africa', 'RE': 'africa', 'RW': 'africa',
  'ST': 'africa', 'SN': 'africa', 'SC': 'africa', 'SL': 'africa', 'SO': 'africa',
  'ZA': 'africa', 'SS': 'africa', 'SD': 'africa', 'TZ': 'africa', 'TG': 'africa',
  'TN': 'africa', 'UG': 'africa', 'ZM': 'africa', 'ZW': 'africa',

  // 大洋洲 (Oceania)
  'AU': 'oceania', 'FJ': 'oceania', 'KI': 'oceania', 'MH': 'oceania', 'FM': 'oceania',
  'NR': 'oceania', 'NZ': 'oceania', 'PW': 'oceania', 'PG': 'oceania', 'WS': 'oceania',
  'SB': 'oceania', 'TO': 'oceania', 'TV': 'oceania', 'VU': 'oceania',
};

// 大洲显示名称映射
const continentDisplayNames = {
  'asia': 'Asia',
  'europe': 'Europe',
  'north-america': 'North America',
  'central-america': 'Central America',
  'caribbean': 'Caribbean',
  'south-america': 'South America',
  'africa': 'Africa',
  'oceania': 'Oceania',
  'multi-region': 'Multi-Region'
};

/**
 * 根据国家 ISO 代码获取大洲
 * @param {string} countryCode - 国家 ISO 代码 (例如: 'US', 'CN', 'GB', 'AS31', 'UN-146', 'Global', 'EU')
 * @returns {string} 大洲代码 ('asia', 'europe', 'north-america', 'central-america', 'caribbean', 'south-america', 'africa', 'oceania', 'multi-region')
 */
export function getContinentByCountry(countryCode) {
  if (!countryCode) {
    return 'multi-region';
  }

  // 处理特殊代码和名称
  const upperCode = countryCode.toUpperCase().trim();
  
  // 处理特殊区域代码
  if (upperCode === 'GLOBAL' || upperCode === 'GLOBAL-REGION' || upperCode === 'WORLD') {
    return 'multi-region';
  }
  
  // 处理欧盟
  if (upperCode === 'EU' || upperCode === 'EUROPEAN-UNION' || upperCode === 'EUROPEAN UNION') {
    return 'europe'; // 欧盟主要在欧洲，但也可以归类为多区域
  }
  
  // 处理UN M.49代码 (AS31, AS25 等表示亚洲区域)
  if (upperCode.startsWith('AS')) {
    return 'asia';
  }
  
  // 处理UN代码 (UN-146 等，需要根据具体代码判断，这里先归类为多区域)
  if (upperCode.startsWith('UN-')) {
    // UN-146 通常表示东欧，归类为欧洲
    if (upperCode === 'UN-146') {
      return 'europe';
    }
    // 其他UN代码暂时归类为多区域
    return 'multi-region';
  }
  
  // 处理Kosovo (可能使用非官方代码 XK 或名称)
  if (upperCode === 'KOSOVO' || upperCode === 'XK') {
    return 'europe';
  }

  // 转换为大写，处理可能的连字符（如 'US-CA' -> 'US'）
  const code = upperCode.split('-')[0].trim();
  
  // 检查是否是有效的 ISO 3166-1 alpha-2 代码（2个字符）
  if (code.length !== 2) {
    return 'multi-region';
  }

  // 查找大洲
  const continent = countryToContinentMap[code];
  
  // 如果找不到，返回 'multi-region'
  return continent || 'multi-region';
}

/**
 * 获取大洲的显示名称
 * @param {string} continentCode - 大洲代码
 * @returns {string} 大洲显示名称
 */
export function getContinentDisplayName(continentCode) {
  return continentDisplayNames[continentCode] || continentCode;
}

/**
 * 按大洲分组国家列表
 * @param {Object} productList - 产品列表对象，key 是国家代码，value 是产品数组
 * @returns {Object} 按大洲分组的对象，格式: { 'asia': { 'CN': [...], 'JP': [...] }, ... }
 */
export function groupCountriesByContinent(productList) {
  const grouped = {};

  if (!productList || typeof productList !== 'object') {
    return grouped;
  }

  Object.keys(productList).forEach(countryCode => {
    const continent = getContinentByCountry(countryCode);
    
    if (!grouped[continent]) {
      grouped[continent] = {};
    }
    
    grouped[continent][countryCode] = productList[countryCode];
  });

  return grouped;
}

/**
 * 获取大洲的排序顺序（用于显示）
 * @returns {Array} 大洲代码数组，按显示顺序排列
 */
export function getContinentOrder() {
  return ['asia', 'europe', 'north-america', 'central-america', 'caribbean', 'south-america', 'africa', 'oceania', 'multi-region'];
}

export default {
  getContinentByCountry,
  getContinentDisplayName,
  groupCountriesByContinent,
  getContinentOrder
};
